//i want to 
import BlogSection from "../components/blog";
import SocialWidget from "../components/floatingwidget";
import HeroSection from "../components/hero";
import QuickLinks from "../components/quicklinks";
import {FaPhoneAlt } from "react-icons/fa";

export default function Homepage() {

  return (
    <div className="w-full font-sans">
      <HeroSection />
      <QuickLinks/>

      <section>
        <div>
        <img
            src="/images/whistleblowerbanner.png"
            alt="Whistleblower Banner"
            className="w-full h-auto object-cover"
          />
          </div>
      </section>
   
    
<section className="w-full py-12 md:py-8 bg-yellow-400"> 
   <div className="container mx-auto px-4 sm:px-6 lg:px-8">
    <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 xl:gap-16">
      
      {/* Image Side */}
      <div className="lg:w-1/2 w-full">
        <div className="relative group">                
          <div className="relative overflow-hidden rounded-2xl shadow-xl border-4 border-black">
            <img
              src="/images/BEDC-MAP.jpg"
              alt="BEDC Team Working"
              className="w-full h-auto min-h-[250px] sm:min-h-[350px] md:min-h-[400px] object-cover transform transition-transform duration-700 group-hover:scale-105 group-hover:brightness-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
          </div>
          <div className="absolute -top-3 -left-3 w-12 h-12 border-t-4 border-l-4 border-black rounded-tl-2xl opacity-80 group-hover:opacity-100 transition-opacity duration-300"></div>
        </div>
      </div>

      {/* Content Side */}
      <div className="lg:w-1/2 w-full">
        <div className="flex items-center gap-3 mb-3 md:mb-4">
          <div className="w-8 md:w-10 h-1 bg-[#14532d] rounded-full"></div> 
          <h3 className="text-xs md:text-sm font-bold text-[#14532d] uppercase tracking-wider">
            Our Commitment
          </h3>
        </div>
        
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-black mb-4 leading-tight">
        Committed to serving 
          <span className="block text-[#14532d]">you better.</span>
        </h2>
        
        <p className="text-sm sm:text-base md:text-lg text-gray-900 mb-6 font-normal leading-relaxed">
          As the 4th largest Disco in Nigeria, we are providing electricity with 
          excellent service delivery, operating with high safety standards. 
          And we are even closer to our customers than ever.
        </p>
        
        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 mb-6">
          {/* Primary Button: Green */}
          <a href="/about-us">
            <button className="group relative bg-[#14532d] text-white font-bold py-3 px-6 md:px-8 rounded-xl transition-all duration-300 overflow-hidden hover:shadow-xl hover:-translate-y-0.5 text-xs sm:text-sm">
              <span className="relative flex items-center justify-center gap-2">
                About Us
                <span className="transform transition-transform duration-300 group-hover:translate-x-1">→</span>
              </span>
            </button>
          </a>
          
          {/* Secondary Button: Black/Outline */}
          <a href="https://newsetup.beninelectric.com" target="_blank" rel="noopener noreferrer">
            <button className="group relative border-2 border-black text-black font-bold py-3 px-6 md:px-8 rounded-xl transition-all duration-300 overflow-hidden hover:bg-black hover:text-white hover:shadow-lg hover:-translate-y-0.5 text-xs sm:text-sm">
              <span className="relative flex items-center justify-center gap-2">
               Join our Network
                <span className="transform transition-transform duration-300 group-hover:translate-x-1">→</span>
              </span>
            </button>
          </a>
        </div>
        
        {/* Additional Features: Icons switched to Green/Black */}
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="group flex items-center gap-3 p-2.5 rounded-lg hover:bg-white/30 transition-all duration-300 cursor-pointer border border-transparent hover:border-black/10">
            <div className="w-8 h-8 bg-[#14532d] rounded-full flex items-center justify-center transition-colors duration-300">
              <div className="w-2.5 h-2.5 bg-white rounded-full group-hover:scale-125 transition-transform duration-300"></div>
            </div>
            <span className="text-xs sm:text-sm font-bold text-black">
              24/7 Customer Support
            </span>
          </div>
          
          <div className="group flex items-center gap-3 p-2.5 rounded-lg hover:bg-white/30 transition-all duration-300 cursor-pointer border border-transparent hover:border-black/10">
            <div className="w-8 h-8 bg-black rounded-full flex items-center justify-center transition-colors duration-300">
              <div className="w-2.5 h-2.5 bg-[#facc15] rounded-full group-hover:scale-125 transition-transform duration-300"></div>
            </div>
            <span className="text-xs sm:text-sm font-bold text-black">
              Rapid Response Team
            </span>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
    
 
      <section>
        <BlogSection/>
      </section>
    
      
    
  <section className="bg-black text-white py-8">
          <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 text-center">
            <div className="inline-block p-3 bg-[#14532d] rounded-full mb-6">
              <FaPhoneAlt className="text-2xl text-white" />
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 uppercase tracking-tight">
              Need Immediate <span className="text-yellow-400">Assistance?</span>
            </h2>
            <p className="text-sm sm:text-base opacity-90 mb-8 max-w-2xl mx-auto font-normal leading-relaxed">
              Our customer care team is available 24/7 to address your concerns and provide solutions.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:07000002332"
                className="bg-yellow-400 text-black font-bold px-8 py-4 rounded-xl hover:bg-white transition-all flex items-center justify-center gap-2 uppercase tracking-wider text-xs shadow-lg"
              >
                Call Now: 0700 000 2332
              </a>
              <a
                href="/contact"
                className="bg-transparent border-2 border-white text-white font-bold px-8 py-4 rounded-xl hover:bg-white hover:text-black transition-all flex items-center justify-center gap-2 uppercase tracking-wider text-xs shadow-lg"
              >
                Send Message
              </a>
            </div>
          </div>
        </section>

        <SocialWidget/>

    </div>
  );
}


